module.exports = __webpack_public_path__ + "img/info-fill.804e2646.svg";